export const projects = [
  {
    title: "Car Rental Website",
    descriptions: [
      "Developed a feature-rich car rental website using the MERN stack, enhancing the car booking process for users.",
      "Leveraged experience in React to create an intuitive and interactive Front-End.",
      "Prioritized user privacy by implementing a robust and secure authentication system.",
    ],
    skills:
      " ReactJS, MongoDB, ExpressJS, NodeJS, API, Authentication, Authorization",
    github: "https://github.com/Harshil0309/Car-Rental-Website",
    // live: "https://angry-tam-pig.cyclic.app",
  },
  {
    title: " Google Chrome Extension - Youtube Timestamp",
    descriptions: [
      "Developed a Google Chrome browser extension to enhance the user experience on YouTube, allowing users to create and save up to 10 timestamps",
      "Utilized significant DOM manipulation and service workers.",
      "Implemented browser storage to save and manage user-generated timestamps, ensuring a seamless experience across browsing sessions.",
    ],
    skills: " HTML, JavaScript, Chrome Extension, API",
    github: "https://github.com/Harshil0309/YT-Timestamp-Extension",
    // live: "https://github.com/Harshil0309/YT-Timestamp-Extension",
  },
  {
    title: "BingeFlix",
    descriptions: [
      "Focused on delivering a wealth of information of about more than 200K films, making it a go-to resource for user seeking comprehensive details on movies.",
      "Utilized ReactJS for the front-end development of the website, creating a responsive user interface.",
      "Successfully integrated APIs to fetch the data and display it on the user interface.",
    ],
    skills: "  ReactJS, CSS, API",
    github: "https://github.com/Harshil0309/BingeFlix",
    live: "https://binge-flix-n7wf5egif-harshil0309s-projects.vercel.app/",
  },
];
